// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__11_Pq","right":"styles_right__34VaV","left":"styles_left__Ul_7y","estimated_value":"styles_estimated_value__39Npj"};